import { SQDCEventActionTypeInternalType } from "@/graphql";

export const PSC_EVENT_INTERNAL_TYPES = [SQDCEventActionTypeInternalType.PSC] as const;
